import { render, staticRenderFns } from "./aboutchild.vue?vue&type=template&id=42547a60"
import script from "./aboutchild.vue?vue&type=script&lang=js"
export * from "./aboutchild.vue?vue&type=script&lang=js"
import style0 from "./aboutchild.vue?vue&type=style&index=0&id=42547a60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports